import { environment } from '@env/environment';

import { GetRequestData, PostRequestData } from '../utils';
import {
  BulkJobActionBody,
  JobsListParams,
  SingleJobActionBody,
} from './types';

function buildQuery(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === '') {
      continue;
    }
    search.set(key, String(value));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export class StatusApi {
  private static readonly base = `${environment.backendURL}/api/status`;

  static getQueues(group?: string): GetRequestData {
    return {
      url: `${StatusApi.base}/queues${buildQuery({ group })}`,
    };
  }

  static getJobs(params: JobsListParams = {}): GetRequestData {
    return {
      url: `${StatusApi.base}/jobs${buildQuery({
        queue: params.queue,
        group: params.group,
        status: params.status,
        name: params.name,
        states: params.states,
        limit: params.limit,
        offset: params.offset,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      })}`,
    };
  }

  static getJob(jobId: string, queue?: string): GetRequestData {
    return {
      url: `${StatusApi.base}/jobs/${encodeURIComponent(jobId)}${buildQuery({ queue })}`,
    };
  }

  static getJobLogs(jobId: string, queue?: string, start = 0, end = -1): GetRequestData {
    return {
      url: `${StatusApi.base}/jobs/${encodeURIComponent(jobId)}/logs${buildQuery({
        queue,
        start,
        end,
      })}`,
    };
  }

  static runJobAction(jobId: string, body: SingleJobActionBody): PostRequestData<SingleJobActionBody> {
    return {
      url: `${StatusApi.base}/jobs/${encodeURIComponent(jobId)}/action`,
      body,
    };
  }

  static runBulkJobAction(body: BulkJobActionBody): PostRequestData<BulkJobActionBody> {
    return {
      url: `${StatusApi.base}/jobs/action`,
      body,
    };
  }
}
